import {
  COMPONENT_CLASS,
  COMPONENT_NAME,
  EVENT,
  SELECTED_OPTION,
} from '@jusbrasil-web/shared-ga4-events'

const componentClass = COMPONENT_CLASS.COMPLETE_SIGNUP_NUDGE

export const NUDGE_RENDER_PROPS = {
  CPF_DOB: {
    componentClass,
    componentName: COMPONENT_NAME.COMPLETE_SIGNUP_NUDGE_CPF_DOB,
    renders: [
      {
        item_variant: null,
        item_brand: null,
        item_name: COMPONENT_NAME.COMPLETE_SIGNUP_NUDGE_CPF_DOB,
        item_id: null,
      },
    ],
  },
  PHONE: {
    componentClass,
    componentName: COMPONENT_NAME.COMPLETE_SIGNUP_NUDGE_PHONE,
    renders: [
      {
        item_variant: null,
        item_brand: null,
        item_name: COMPONENT_NAME.COMPLETE_SIGNUP_NUDGE_PHONE,
        item_id: null,
      },
    ],
  },
  SUCCESS: {
    componentClass,
    componentName: COMPONENT_NAME.COMPLETE_SIGNUP_NUDGE_SUCCESS,
    renders: [
      {
        item_variant: null,
        item_brand: null,
        item_name: COMPONENT_NAME.COMPLETE_SIGNUP_NUDGE_SUCCESS,
        item_id: null,
      },
    ],
  },
}

export const NUDGE_CLICK_PROPS = {
  CPF_DOB_SKIP: {
    componentClass,
    componentName: COMPONENT_NAME.COMPLETE_SIGNUP_NUDGE_CPF_DOB,
    selectedOption: SELECTED_OPTION.SKIP,
    resourceId: null,
  },
  PHONE_SKIP: {
    componentClass,
    componentName: COMPONENT_NAME.COMPLETE_SIGNUP_NUDGE_PHONE,
    selectedOption: SELECTED_OPTION.SKIP,
    resourceId: null,
  },
  SUCCESS_COMPLETE: {
    componentClass,
    componentName: COMPONENT_NAME.COMPLETE_SIGNUP_NUDGE_SUCCESS,
    selectedOption: SELECTED_OPTION.COMPLETE,
    resourceId: null,
  },
}

export const NUDGE_CLOSE_CLICK_PROPS = {
  CPF_DOB: {
    componentClass,
    componentName: COMPONENT_NAME.COMPLETE_SIGNUP_NUDGE_CPF_DOB,
    selectedOption: SELECTED_OPTION.EXIT,
    resourceId: null,
  },
  PHONE: {
    componentClass,
    componentName: COMPONENT_NAME.COMPLETE_SIGNUP_NUDGE_PHONE,
    selectedOption: SELECTED_OPTION.EXIT,
    resourceId: null,
  },
  SUCCESS: {
    componentClass,
    componentName: COMPONENT_NAME.COMPLETE_SIGNUP_NUDGE_SUCCESS,
    selectedOption: SELECTED_OPTION.EXIT,
    resourceId: null,
  },
  // The validating and error steps have no close mapping of their own; a close on them is
  // attributed here instead of falling back to the cpf+dob step.
  IDENTITY_VALIDATION: {
    componentClass,
    componentName: COMPONENT_NAME.IDENTITY_VALIDATION,
    selectedOption: SELECTED_OPTION.EXIT,
    resourceId: null,
  },
}

export const NUDGE_INPUT_START_PROPS = {
  CPF_DOB: {
    componentClass,
    componentName: COMPONENT_NAME.COMPLETE_SIGNUP_NUDGE_CPF_DOB,
    featureClass: null,
    featureName: null,
    inputMethod: EVENT.TEXT_TYPE,
  },
  PHONE: {
    componentClass,
    componentName: COMPONENT_NAME.COMPLETE_SIGNUP_NUDGE_PHONE,
    featureClass: null,
    featureName: null,
    inputMethod: EVENT.TEXT_TYPE,
  },
}

export const NUDGE_INPUT_SUBMIT_PROPS = {
  CPF_DOB: {
    componentClass,
    componentName: COMPONENT_NAME.COMPLETE_SIGNUP_NUDGE_CPF_DOB,
    featureClass: null,
    featureName: null,
    inputMethod: EVENT.TEXT_TYPE,
    successfulAttempt: true,
  },
  PHONE_TRUE: {
    componentClass,
    componentName: COMPONENT_NAME.COMPLETE_SIGNUP_NUDGE_PHONE,
    featureClass: null,
    featureName: null,
    inputMethod: EVENT.TEXT_TYPE,
    successfulAttempt: true,
  },
  PHONE_FALSE: {
    componentClass,
    componentName: COMPONENT_NAME.COMPLETE_SIGNUP_NUDGE_PHONE,
    featureClass: null,
    featureName: null,
    inputMethod: EVENT.TEXT_TYPE,
    successfulAttempt: false,
  },
}
